import { TidStatusDto } from "./TidStatusDto";

export interface ITerminalInfoDto {
    terminalList?: TerminalItemDto[]
}

export class TerminalInfoDto implements ITerminalInfoDto {
    public terminalList?: TerminalItemDto[]

    constructor(terminalList?: TerminalItemDto[]) {
        this.terminalList = terminalList;
    }
}

export class TerminalItemDto {
    public termId: string;
    public terminalStatus: TidStatusDto;
    public terminalType: string;
    public softposType: string | null;

    constructor(termId: string, terminalStatus: TidStatusDto, terminalType: string, softposType: string | null) {
        this.termId = termId;
        this.terminalStatus = terminalStatus;
        this.terminalType = terminalType;
        this.softposType = softposType;
    }
}
